
import ButtonStepMenu from "@/views/components/ButtonStepMenu.vue";
import LoggedInBar from "@/views/partials/LoggedInBar.vue";
import MyLogo from "@/views/partials/RentersLogo.vue";
import QuoteIntroduction from "@/views/quote/QuoteIntroduction.vue";
import QuoteQuestions from "@/views/quote/QuoteQuestions.vue";
import QuoteQuote from "@/views/quote/QuoteQuote.vue";
import QuoteAccount from "@/views/quote/QuoteAccount.vue";
import QuoteCheckout from "@/views/quote/QuoteCheckout.vue";
import QuoteCartMobile from "@/views/quote/QuoteCartMobile.vue";
import QuoteReview from "@/views/quote/QuoteReview.vue";
import QuoteDone from "@/views/quote/QuoteDone.vue";
import QuoteDoneFailedNssiApi from "@/views/quote/QuoteDoneFailedNssiApi.vue";
import QuoteDoneFailedRentersApi from "@/views/quote/QuoteDoneFailedRentersApi.vue";
import QuoteDeniedCA from "@/views/quote/QuoteDeniedCA.vue";
import QuoteDeniedGeneric from "@/views/quote/QuoteDeniedGeneric.vue";
import QuoteAddon from "@/views/quote/QuoteAddon.vue";
import { addNoScroll, removeNoScroll } from "@/utils/NoScroll";
import {
  defineComponent,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  inject,
  ref,
  Ref,
  watch,
} from "vue";
import { storeToRefs } from "pinia";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";
import useQuote from "@/hooks/useQuote";
import quotes from "@/assets/quotes";
import { getCurrentYear } from "@/utils/Utils";
import { useRouter } from "vue-router";
import router from "@/router";

export default defineComponent({
  name: "QuoteBase",
  components: {
    ButtonStepMenu,
    LoggedInBar,
    MyLogo,
    QuoteIntroduction,
    QuoteQuestions,
    QuoteQuote,
    QuoteAccount,
    QuoteCheckout,
    QuoteReview,
    QuoteDone,
    QuoteDoneFailedNssiApi,
    QuoteDoneFailedRentersApi,
    QuoteDeniedCA,
    QuoteDeniedGeneric,
    QuoteCartMobile,
    QuoteAddon,
  },
  setup() {
    const quote = useQuoteStore();
    const user = useUserStore();
    const { currentStep } = storeToRefs(quote);
    const {
      toShowMenuSteps,
      wizardComponent,
      wizardTitle,
      menuQuoteSteps,
      toShowMobileCart,
    } = useQuote(currentStep);
    const inj = inject("$emitter");
    //TODO what use anchor and loaded
    const anchor: Ref<string> = ref("");
    //const loaded: Ref<boolean> = ref(false);
    const showStepMenu: Ref<boolean> = ref(true);
    const ruter = useRouter();
    //TODO fix scrooll, only for Payment
    // const toShowCartMobile = ref(false);

    /**
     * Show this.currentStep page
     */
    // function showPage(onCreation = false) {
    //   if (!onCreation) {
    //     const instance = getCurrentInstance();
    //     instance?.proxy?.$forceUpdate();
    //     if (!anchor.value) {
    //       scrollTop();
    //     }
    //   }
    //   loaded.value = true;
    // }
    //to hide the stepMeny when denied from assurand
    watch(quote, (current) => {
      if (current.currentStep == "quote-denied") {
        showStepMenu.value = false;
      }
    });
    onBeforeMount(() => {
      // renters/quote is inserted directly into url to redirect
      if (!sessionStorage.getItem("log") && quote.currentStep != "quote-done") {
        router.push("home");
      }
      if (currentStep.value == "") {
        goToPage("quote-introduction");
      } else {
        goToPage(currentStep.value);
      }
      //to hide the stepMeny when denied from assurand
      if (currentStep.value == "quote-denied") {
        showStepMenu.value = false;
      }
    });

    const toShowMobileStepMenu = ref(false);

    const closeMobileStepMenu = () => {
      toShowMobileStepMenu.value = false;
      removeNoScroll();
    };

    const openMobileStepMenu = () => {
      toShowMobileStepMenu.value = true;
      addNoScroll();
    };

    /**
     * Go directly to a specific page.
     */
    function goToPage(command: string) {
      // currentStep.value = step;
      // loaded.value = true;
      // anchor.value = "";
      quote.setQuoteStep(command);
      // showPage();
      // toShowMobileStepMenu.value = false;
    }

    /**
     * Back or forward button has been clicked on browser.
     */
    function onPopState() {
      // Remove no scroll, so when we return to the main window it can scroll
      removeNoScroll();
    }

    function mobileCartHidden() {
      removeNoScroll();
    }

    onMounted(() => {
      // Register browser back/forward event
      window.addEventListener("popstate", onPopState);
      (inj as any).on("hide-mobile-cart", () => {
        mobileCartHidden();
      });
    });

    onBeforeUnmount(() => {
      // remove the event listener
      window.removeEventListener("popstate", onPopState);
      (inj as any).off("hide-mobile-cart");
    });

    return {
      goToPage,
      wizardComponent,
      wizardTitle,
      anchor,
      //loaded,
      toShowMenuSteps,
      toShowMobileCart,
      toShowMobileStepMenu,
      closeMobileStepMenu,
      openMobileStepMenu,
      menuQuoteSteps,
      quotes,
      getCurrentYear,
      showStepMenu,
    };
  },
});
